"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.perCoinLogic = exports.bchToCashaddrAddressWithoutPrefix = exports.getUTXOStatus = exports.isValidRecipient = exports.inferFeePerByte = exports.getMinRelayFee = void 0;
var cashaddrjs_1 = __importDefault(require("cashaddrjs"));
var wallet_btc_1 = require("./wallet-btc");
var errors_1 = require("@ledgerhq/errors");
// correspond ~ to min relay fees but determined empirically for a tx to be accepted by network
var minFees = {
    bitcoin: 1000,
    bitcoin_gold: 1000,
    pivx: 2000,
    stakenet: 1000,
    stealthcoin: 2000,
    qtum: 4000,
    stratis: 2000,
    vertcoin: 2000,
    viacoin: 2000,
    peercoin: 2000
};
var getMinRelayFee = function (currency) {
    return minFees[currency.id] || 0;
};
exports.getMinRelayFee = getMinRelayFee;
var inferFeePerByte = function (t, networkInfo) {
    if (t.feesStrategy) {
        var speed = networkInfo.feeItems.items.find(function (item) { return t.feesStrategy === item.speed; });
        if (!speed) {
            return networkInfo.feeItems.defaultFeePerByte;
        }
        return speed.feePerByte;
    }
    return t.feePerByte || networkInfo.feeItems.defaultFeePerByte;
};
exports.inferFeePerByte = inferFeePerByte;
var isValidRecipient = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var valid;
    return __generator(this, function (_a) {
        if (!params.recipient) {
            return [2 /*return*/, Promise.reject(new errors_1.RecipientRequired(""))];
        }
        try {
            // Optimistically assume params.currency.id is an actual Currency
            valid = (0, wallet_btc_1.isValidAddress)(params.recipient, params.currency.id);
        }
        catch (e) {
            // isValidAddress() will throw Error if c is not an actual Currency
            valid = false;
        }
        if (!valid) {
            return [2 /*return*/, Promise.reject(new errors_1.InvalidAddress("", {
                    currencyName: params.currency.name
                }))];
        }
        return [2 /*return*/, Promise.resolve(null)];
    });
}); };
exports.isValidRecipient = isValidRecipient;
var getUTXOStatus = function (utxo, utxoStrategy) {
    if (!utxoStrategy.pickUnconfirmedRBF && utxo.rbf && !utxo.blockHeight) {
        return {
            excluded: true,
            reason: "pickUnconfirmedRBF"
        };
    }
    if (!utxo.rbf && !utxo.blockHeight) {
        return {
            excluded: true,
            reason: "pickPendingNonRBF"
        };
    }
    if (utxoStrategy.excludeUTXOs.some(function (u) { return u.hash === utxo.hash && u.outputIndex === utxo.outputIndex; })) {
        return {
            excluded: true,
            reason: "userExclusion"
        };
    }
    return {
        excluded: false
    };
};
exports.getUTXOStatus = getUTXOStatus;
var bchExplicit = function (str) {
    var explicit = str.includes(":") ? str : "bitcoincash:" + str;
    try {
        var type = cashaddrjs_1["default"].decode(explicit).type;
        if (type === "P2PKH")
            return explicit;
    }
    catch (e) {
        // ignore errors
    }
    return str;
};
var bchToCashaddrAddressWithoutPrefix = function (recipient) {
    return recipient ? recipient.substring(recipient.indexOf(":") + 1) : recipient;
};
exports.bchToCashaddrAddressWithoutPrefix = bchToCashaddrAddressWithoutPrefix;
exports.perCoinLogic = {
    zencash: {
        hasExtraData: true
    },
    zcash: {
        hasExtraData: true,
        hasExpiryHeight: true,
        getAdditionals: function () { return ["sapling"]; }
    },
    komodo: {
        hasExtraData: true,
        hasExpiryHeight: true,
        getAdditionals: function () { return ["sapling"]; }
    },
    decred: {
        hasExpiryHeight: true
    },
    bitcoin_gold: {
        getAdditionals: function () { return ["bip143"]; }
    },
    bitcoin_cash: {
        getAdditionals: function (_a) {
            var transaction = _a.transaction;
            var additionals = ["bip143"];
            if (bchExplicit(transaction.recipient).startsWith("bitcoincash:")) {
                additionals.push("cashaddr");
            }
            return additionals;
        },
        // Due to minimal support, we need to return the explicit format of bitcoincash:.. if it's a P2PKH
        asExplicitTransactionRecipient: bchExplicit,
        // to represent what happens on the device, which do not display the bitcoincash: prefix
        onScreenTransactionRecipient: function (str) {
            var prefix = "bitcoincash:";
            return str.startsWith(prefix) ? str.slice(prefix.length) : str;
        },
        syncReplaceAddress: function (addr) { return (0, exports.bchToCashaddrAddressWithoutPrefix)(addr); },
        injectGetAddressParams: function () { return ({
            forceFormat: "cashaddr"
        }); }
    }
};
//# sourceMappingURL=logic.js.map